// core
import { useState, useEffect, useCallback } from "react";

interface IWindowDimensions {
    width: number;
    height: number;
    isMobile: boolean;
    isTabletPortrait: boolean;
    isTabletLandscape: boolean;
    isDesktop: boolean;
    isWide: boolean;
}
export default function useWindowDimensions(): IWindowDimensions {
    const hasWindow = typeof window !== "undefined";

    const getWindowDimensions = useCallback((): IWindowDimensions => {
        const width = hasWindow ? window.innerWidth : null;
        const height = hasWindow ? window.innerHeight : null;

        // The breakpoints are based on LifeDirect.Web/sass/mixins/_mq.scss definitions
        return {
            width,
            height,
            isMobile: width <= 320, // Is Mobile is rarely used
            isTabletPortrait: width <= 768,
            isTabletLandscape: width <= 1024,
            isDesktop: width <= 1024,
            isWide: width <= 1240
        };
    }, [hasWindow]);

    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect((): React.EffectCallback => {
        if (hasWindow) {
            const handleResize = (): void => {
                setWindowDimensions(getWindowDimensions());
            };

            window.addEventListener("resize", handleResize);
            return (): void => window.removeEventListener("resize", handleResize);
        }
    }, [hasWindow, getWindowDimensions]);

    return windowDimensions;
}
